export enum AllowedMediaTypes {
  jpg = "jpg",
  jpeg = "jpeg",
  png = "png",
  gif = "gif",
  eot = "eot",
  otf = "otf",
  webp = "webp",
  svg = "svg",
  ttf = "ttf",
  woff = "woff",
  woff2 = "woff2",
  mp4 = "mp4",
  webm = "webm",
  wav = "wav",
  mp3 = "mp3",
  m4a = "m4a",
  aac = "aac",
  oga = "oga",
  pdf = "pdf",
}

export const IMAGE_MEDIA_TYPES: AllowedMediaTypes[] = [
  AllowedMediaTypes.gif,
  AllowedMediaTypes.jpeg,
  AllowedMediaTypes.jpg,
  AllowedMediaTypes.png,
  AllowedMediaTypes.svg,
  AllowedMediaTypes.webp,
];

export const VIDEO_MEDIA_TYPES: AllowedMediaTypes[] = [
  AllowedMediaTypes.mp4,
  AllowedMediaTypes.webm,
  AllowedMediaTypes.wav,
  AllowedMediaTypes.mp3,
  AllowedMediaTypes.m4a,
  AllowedMediaTypes.aac,
  AllowedMediaTypes.oga,
];

export const ALLOWED_MEDIA_TYPES: AllowedMediaTypes[] =
  Object.values(AllowedMediaTypes);
